import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../components/features/auth/authSlice";
import courseReducer from "../components/features/courses/courseSlice";
import competitionReducer from "../components/features/competition/competitionSlice";
import cohortReducer from "../components/features/cohort/cohortSlice";
import simulationReducer from "../components/features/simulation/simulationSlice";
//import lessonReducer from "../components/features/courses/lessonSlice";
//import noteReducer from "../features/notes/noteSlice";

export const store = configureStore({
  reducer: {
    courses: courseReducer,
    auth: authReducer,
    competitions: competitionReducer,
    cohort: cohortReducer,
    simulation: simulationReducer,
    //lesson: lessonReducer,
  },
});
